<template>
  <permission-guard situation="site_configuration">
    <v-form>
      <v-row class="mb-3">
        <v-col cols="6">
          <v-text-field
            v-model="rssFormat.num"
            class="mb-3"
            label="記事数"
            style="width: 300px"
            type="number"
          />
          <v-btn-toggle v-model="rssFormat.order" outlined mandatory>
            <v-btn value="desc"> 新しい順 </v-btn>
            <v-btn value="asc"> 古い順 </v-btn>
          </v-btn-toggle>
        </v-col>
        <v-col cols="6">
          <v-switch
            v-model="rssFormat.includePublished"
            persistent-hint
            hint="※RSSフィードに公開記事を含みます"
            label="公開記事を抽出"
          />
          <v-switch
            v-model="rssFormat.includeUpdated"
            persistent-hint
            hint="※RSSフィードに更新記事を含みます"
            label="更新記事を抽出"
          />
          <v-switch
            v-model="rssFormat.includeDeleted"
            persistent-hint
            hint="※RSSフィードに非公開記事を含みます"
            label="非公開記事を抽出"
          />
          <v-spacer />
          <v-alert
            dense
            outlined
            class="mt-3"
            type="error"
            style="width: 400px"
          >
            <span class="caption">
              公開されている記事でも編集を加えている場合は、更新記事に含まれます。
            </span>
          </v-alert>
        </v-col>
      </v-row>
      <div class="ma-3">
        <v-btn
          class="mt-2 mb-0"
          outlined
          color="indigo"
          @click="addRssCategory"
        >
          カテゴリー変換ルールを追加
        </v-btn>
      </div>
      <v-row
        v-for="(value, index) in rssFormat.rssCategories"
        :key="index"
        align="center"
        class="mb-3"
      >
        <v-col cols="5">
          <v-text-field
            v-model="value['afterValue']"
            class="mb-0 caption"
            label="変換後のカテゴリー名"
            required
            placeholder="雑貨"
          />
        </v-col>
        <v-col cols="5">
          <v-select
            v-model="value['categoryName']"
            :items="rssFormat.beforeCategories"
            item-text="categoryName"
            item-value="categoryName"
            hide-selected
            label="変換対象のカテゴリー名"
            required
            placeholder="ライフスタイル"
          />
        </v-col>
        <v-col cols="1" align="center">
          <v-btn color="error" outlined small @click="deleteRssCategory(index)">
            削除
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-btn color="green darken-1" tile dark depressed @click="updateSite">
      更新
    </v-btn>
  </permission-guard>
</template>
<script>
import axios from 'axios'
import PermissionGuard from '@/components/commons/PermissionGuard'

export default {
  components: {
    PermissionGuard
  },
  props: {
    siteId: {
      type: Number,
      required: true
    },
    formatName: {
      type: String,
      required: true
    }
  },
  data: () => {
    return {
      rssFormat: {},
      destroyRssCategories: []
    }
  },
  mounted: function () {
    axios.get(`/api/rss_feeds/${this.formatName}/edit`).then(
      ({ data }) => {
        this.rssFormat = data.data.attributes
      },
      (error) => {
        const payload = {
          status: error.response.status,
          message: error.response.data.errors.toString()
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
      }
    )
  },
  methods: {
    addRssCategory () {
      this.rssFormat.rssCategories.push({
        id: null,
        tagId: null,
        afterValue: null,
        _destroy: false
      })
    },
    deleteRssCategory (index) {
      this.rssFormat.rssCategories[index]._destroy = true
      this.destroyRssCategories.push(this.rssFormat.rssCategories[index])
      this.rssFormat.rssCategories.splice(index, 1)
    },
    updateSite () {
      const rssFormat = this.rssFormat
      // tag_idをセット
      rssFormat.rssCategories.forEach((el) => {
        if (el.tag_id == null) {
          let beforeCategory = {}
          beforeCategory = this.rssFormat.beforeCategories.find(
            (v) => v.categoryName === el.categoryName
          )
          el.tag_id = beforeCategory['id']
        }
      })
      const query = {
        rssFormat: {
          num: rssFormat.num,
          order: rssFormat.order,
          includePublished: rssFormat.includePublished,
          includeUpdated: rssFormat.includeUpdated,
          includeDeleted: rssFormat.includeDeleted,
          rssTxCategoriesAttributes: rssFormat.rssCategories.concat(
            this.destroyRssCategories
          )
        }
      }
      axios.patch(`/api/rss_feeds/${this.formatName}`, query).then(
        ({ data }) => {
          const payload = {
            status: 200,
            message: '変更を保存しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
          this.rssFormat = data.data.attributes
          this.destroyRssCategories = []
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.statusText.toString()
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    }
  }
}
</script>

<style scoped></style>
